export default "__VITE_ASSET__C2Pccd66__"